import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { ResumenGuiaView } from "app/features/componentes/guia/resumenguia";
import { StatusRastreoDTOList } from "./listastatus";
import { BarraEstados, statusToEstado } from "./estados";
import { BarraEstadosHistoricos, statusToEstadoHistorico } from "./estadoshistoricos";
import { FirmaCadenaComponent } from "app/features/componentes/firmacadena";

interface propsRecibio {
    value: models.InformacionCliente | null
}

class InformacionRecibio extends React.PureComponent<propsRecibio> {
    value = (x: propsRecibio) => x.value;
    render() {
        const value = this.value(this.props);
        return <div>
            {
                value != null ?
                    <div>
                        <kea.Text label="nombre del cliente que recibió:" value={value.NombreCliente} readonly={true} />
                        <FirmaCadenaComponent label="Firma del cliente que recibió:" value={value.FirmaUsuario} />
                    </div>
                    : <div />
            }
        </div>
    }
}


type Entity = models.GuiaRastreoDTO;

interface PropsRas {
    value: Entity;
    informacionCliente: models.InformacionCliente | null;
}

class RastreoGuiaViewNoRx extends React.PureComponent<PropsRas> {

    value = (x: PropsRas) => x.value;
    statusGuia = (x: PropsRas) => x.value.StatusActual;
    statusHistorico = (x: PropsRas) => x.value.StatusHistoricos;
    informacionCliente = (x: PropsRas) => x.informacionCliente;

    render() {
        const value = this.value(this.props);
        const status = this.statusGuia(this.props);
        const statusHistorico = this.statusHistorico(this.props);
        const recibio = this.informacionCliente(this.props);

        const estados = statusToEstado(status);
        const estadosHistorico = statusToEstadoHistorico(statusHistorico);

        return (
            <div>
                <h2 style={{ fontFamily: "monospace" }}>{value.Folio}</h2>
                <br />

                <div className="panel panel-default">
                    <div className="panel-heading">
                        <span>
                            <i className="fa fa-" />
                            Estatus de guía
                        </span>
                    </div>
                    <div className="panel-body">
                        {<BarraEstados value={estados} />}
                    </div>
                </div>

                <div className="row">

                    <div className="col-md-5">
                        <div className="panel panel-default">
                            <div className="panel-heading">
                                <span>
                                    <i className="fa fa-" />
                                    Resumen de guía
                                </span>
                            </div>
                            <div className="panel-body">
                                <ResumenGuiaView value={{
                                    CantidadPaquetes: value.CantidadPaquetes,
                                    CantidadSobres: value.CantidadSobres,
                                    EsDeAcuse: value.EsDeAcuse,
                                    FolioGuiaAcuse: value.FolioGuiaAcuse,
                                    NombreSucursalOrigen: value.NombreSucursalOrigen,
                                    NombreSucursalDestino: value.NombreSucursalDestino,
                                    Status: value.StatusActual,
                                    NombreSucursalStatus: value.NombreSucursalActual,
                                    Folio: value.Folio
                                }} puedeVerDatosEntregaCliente={false} />
                                <hr />
                                <br />
                                <kea.Text label="Observaciones:" value={value.Observaciones} multiline readonly />
                            </div>
                        </div>
                    </div>

                    {
                        (models.StatusGuia.EntregadaOcurre == status || models.StatusGuia.EntregadaDomicilio == status || models.StatusGuia.EntregadaZonaExtendida == status) &&
                        <div className="col-md-4">
                            <div className="panel panel-default">
                                <div className="panel-heading">
                                    <span>
                                        <i className="fa fa-" />
                                        Información de recepción de guía
                                    </span>
                                </div>
                                <div className="panel-body">
                                    <InformacionRecibio value={recibio} />
                                </div>
                            </div>
                        </div>
                    }

                    <div className="col-md-3">
                        <BarraEstadosHistoricos value={estadosHistorico} />
                    </div>

                </div>

                <br />
            </div>
        )
    }
}

const RastreoGuiaView = componentToRx(RastreoGuiaViewNoRx);

export interface Props {
    folio: string
}
export class RastreoGuia extends React.PureComponent<Props> {
    folio = (props: Props) => props.folio;
    rastreo = createSelectorRx(this.folio, folio => observeResource(resources.Rastreo.RastrearGuia, folio));
    informacionCliente = createSelectorRx(this.folio, folio => observeResource(resources.Rastreo.ObtenerInformacionCliente, folio));

    render() {
        const rastreo = this.rastreo(this.props);
        const informacionCliente = this.informacionCliente(this.props);
        return <RastreoGuiaView value={rastreo} informacionCliente={informacionCliente} />;
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/rastreo/guia.tsx